import React, { useState, useEffect, useRef  } from 'react';
import {Layout, Menu, Dropdown, Modal, message, Tabs, Table, Space, Button, Avatar, Badge} from 'antd';
import {BellTwoTone} from '@ant-design/icons'
import IconFont from '@/components/iconFont';
import * as User from '@/common/api/user';
import * as http from '@/common/api/headers';
import PersonalInfo from '@/components/userActionMenu/personalInfo';
import SavePasswordInfo from '@/components/userActionMenu/savePassword';
import Cookies from 'react-cookies';
import headerTitle from '@/common/images/headerTitle.png'
import config from '@/config/index'
import headerTitleQh from '@/common/images/headerTitleQh.jpg'
const { Header } = Layout;
import moment from 'moment'
const { TabPane } = Tabs;
function Headers(props) {
    const [menu, setMenu] = useState()
    const [notReadNum,setNotReadNum] = useState(0)
    const personalInfo = useRef()
    const savePasswordInfo = useRef()
    const [userName, setUserName] = useState('')
    const [imgUrl, setImgUrl] = useState('')
    const [data, setdata] = useState([])
    const [pageNum, setPageNum] = useState(1)
    const [loading, setLoading] = useState(true)
    const [getType, setGetType] = useState(1)
    const [content, setContent] = useState()
    const [disabled, setDisabled] = useState(false)
    const [contentVisible, setContentVisible] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [avatarStatus, setAvatarStatus] = useState(false)
    const [isHomeStatus,setIsHomeStatus] = useState(false)
    // 显示表单模态框
    const handleShowPersonalInfo = () => {
        if(personalInfo.current){
            personalInfo.current.showModal()
        }
    }
     // 显示表单模态框
     const handleShowSavePasswordInfo = () => {
        if(savePasswordInfo.current){
            savePasswordInfo.current.showModal()
        }
    }
    // 退出登录
    const handleSingOut = () => {
        Modal.confirm({
            title: '退出登录确认!',
            content: '确认退出当前账号吗?',
            okText: '确认',
            cancelText: '取消',
            onOk() {
                const token = Cookies.load('user_token')
                User.singOut({token: token}).then(res => {
                    if(res.code === 0){
                        message.success('退出成功！');
                        Cookies.remove('user_token')
                        setTimeout(() => {
                            if(React.$socket) {
                                React.$socket.close()
                            }
                            props.history.push('/login')
                        }, 500);
                    }
                })
            }
        });
    }
    // 获取用户信息
    const handleUserInfo = () => {
        User.getUserDetailInfo().then(res => {
            if (res.code === 0 && res.data) {
                const data = res.data
                setUserName(data.realName)
                if (data.avata) {
                    const oldEscape = data.avatar.replace(/\\/g, '用户个人头像')
                    const escapeCharacter = '/'
                    const escape = oldEscape.replace(/用户个人头像/g, `${escapeCharacter}`)
                    const avatar = JSON.parse(escape)
                    if (avatar.fileUrl) {
                        setImgUrl(`${React.$util.getBaseUrl()}/file/files${avatar.fileUrl}`)
                    }
                }
            }
        })
    }
    const handMenuList = () => {
        User.getUserInfo().then(res => {
            if (res.code === 0 && res.data.menuList.length > 0 ) {
                const opt = {
                    primaryKey: 'id',
                    parentKey: 'parentId',
                    startPid: '-1'
                }
                res.data.menuList.some(item => {
                    if (item.menuCode === 'home' && item.menuName === '大屏中心') {
                        setIsHomeStatus(true)
                        return true
                    }
                })
            }
        })
    }
    // 更新头像
    const initAvatar = () => {
        setAvatarStatus(Math.random())
    }
    const columns = [
        {
            title: '序号',
            dataIndex: 'serial',
            key: 'serial',
            render: (text, record, index) => index + 1,
            align: 'center',
            width: 60
        },
        {
            title: '名称',
            dataIndex: 'title',
            key: 'title',
            align: 'center',
            width: 120
        },
        {
            title: '状态',
            dataIndex: 'isRead',
            key: 'isRead',
            align: 'center',
            width: 60,
            render: (text) => {
                return (
                    <span style={{color:text === 2 ? 'red' : ''}}>
                        {
                            text === 1 ? '已读' : '未读'
                        }
                    </span>
                )
            }
        },
        {
            title: '日期',
            dataIndex: 'pushTime',
            key: 'pushTime',
            ellipsis: true,
            render: (text) => {
                if (text) {
                    return moment(text).format('YYYY-MM-DD HH:mm')
                }
            },
            align: 'center',
            width: 120
        },
        // {
        //     title: '内容',
        //     dataIndex: 'content',
        //     key: 'content',
        //     width: 200,
        //     ellipsis: true,
        //     align: 'center'
        // },
        {
            title: '内容',
            dataIndex: 'content',
            key: 'content',
            align: 'center',
            width: 60,
            render: (text,record) =>{
                return(
                    <Space>
                        <a onClick={() => {
                            if (text) {
                                setContentVisible(true)
                                setContent(text)
                                readMsg(record)
                            } else {
                                message.info('暂无内容')
                            }
                        }}
                        >查看</a>
                    </Space>
                )
            }
        }
    ]
    // 阅读消息
    const readMsg = (record) => {
      http.readMsg({messageId: record.id})
          .then(res => {
              if(res.code === 0){
                  setdata(prevData => 
                    prevData.map(item => 
                      item.id === record.id ? { ...item, isRead: 1 } : item
                    )
                  );
              }
          })
    }
    // 查询未读消息数量
    const handleNotReadNum = () => {
        http.getNotReadNum({type: 2})
            .then(res => {
                if(res.code === 0){
                    setNotReadNum(res.data)
                }
            })
    }
    // 公告推送请求
    const getPage = (params) => {
        setLoading(true)
        http.getData(params).then(res => {
            if (res.code === 0) {
                if (res.data.pages === pageNum) {
                    setDisabled(true)
                }
                if (data && data.length > 0) {
                    setdata((list) => {
                        let arr = list.concat(res.data.list)
                        return arr
                    })
                } else {
                    setdata(res.data.list)
                }
            }
        }).finally(() => {
            setLoading(false)
        })
    }
    // 卡片切换
    const callback = (value) => {
        setPageNum(1)
        if (value === '1') {
            setdata([])
            setGetType(1)
        } else {
            setdata([])
            setGetType(2)
        }
    }
    // 查看更多
    const onMore = () => {
        setPageNum((num) => num + 1)
    }
    useEffect(() => {
        const params = {
            pageSize : 10,
            pageNum: pageNum,
            type: getType
        }
        getPage(params)
        handleNotReadNum()
    }, [getType, pageNum])
    /**
     * 跳转回概览图
     */
    const handleHref = () => {
        props.history.push('/home')
    }
    const defaultAvatar = (
        <div className="defaultAvatar">
            <IconFont className="defaultAvatarIcon" type="iconyunicon_gerenxinzhong"/>
        </div>
      );
    useEffect(() => {
        handleUserInfo()
    }, [avatarStatus])
    useEffect(() => {
        handMenuList()
    }, [])
    useEffect(()=>{
        setMenu(
            (
                <Menu>
                    <Menu.Item onClick={() => handleShowPersonalInfo()}>
                        <a>
                            个人信息
                        </a>
                    </Menu.Item>
                    <Menu.Item onClick={() => handleShowSavePasswordInfo()}>
                        <a>
                            修改密码
                        </a>
                    </Menu.Item>
                    <Menu.Item onClick={() => handleSingOut()}>
                        <a>
                            退出登录
                        </a>
                    </Menu.Item>
                </Menu>
            )
        )
        handleUserInfo()
    },[])
    const handleCancel = () => {
        setIsModalVisible(false)
    }
    const contentCancel = () => {
        setContentVisible(false)
        setContent(null)
        handleNotReadNum()
    }
    return (
            <Header
                className="site-layout-background"
                style={{ padding: 0 }}
            >
                <div className="action-menu clearfix">
                    {/*<div className="action-menu-item-name"><p>{userName}</p></div>*/}
                    <Dropdown overlay={menu} overlayClassName="dropdown-menu-sty">
                        <div className="action-menu-item" style={{fontSize:'20px'}} title="个人信息">
                            <div className="avatar">{imgUrl ? <img alt="avatar" src={imgUrl} style={{ width: '100%' }} /> : defaultAvatar}</div>
                            <span className="span-name" style={{color:'white'}}>{userName}</span>
                        </div>
                    </Dropdown>
                    <div className="action-menu-item" onClick={()=>setIsModalVisible(true)} style={{fontSize:'30px',fontWeight: 800}} title="提示信息">
                        <div style={{marginTop: '-8px'}}>
                            <Badge count={notReadNum}>
                                <Avatar icon={<BellTwoTone />} size={30} style={{ backgroundColor: '#fff' }} />
                            </Badge>
                            {/*<IconFont className="action-dom-icon" style={{ color: 'white' }} type="iconlingdang" />*/}
                            {/*<span className="badge-count">99+</span>*/}
                        </div>                   
                    </div>
                    {
                        isHomeStatus ? <div className="action-menu-item" onClick={() => handleHref()} style={{fontSize:'40px',color:'#fff',paddingTop: '2px',boxSizing:'border-box'}} title="主页"><IconFont className="action-dom-icon" style={{color:'white'}} type="iconxianshiping"/></div> : null
                    }
                    <div style={{float: 'left',lineHeight: '72px',paddingTop: '5px',marginLeft:'-30px',boxSizing:'border-box'}}>
                        <img src={config.pubshAdd === 'tj' ? headerTitle : headerTitleQh} />
                    </div>
                </div>
                <PersonalInfo ref={personalInfo} initAvatar={initAvatar}/>
                <SavePasswordInfo ref={savePasswordInfo}/>
                {/*公告推送*/}
                <Modal
                    title=""
                    visible={isModalVisible}
                    width={600}
                    onCancel={()=>handleCancel()}
                    footer={[
                        <Button key="back" onClick={()=>handleCancel()}>
                            关闭
                        </Button>
                    ]}
                >
                    <Tabs defaultActiveKey="1" onChange={callback}>
                        <TabPane tab="公告管理" key="1">
                            <div>
                                <Table bordered pagination={false} loading={loading} rowKey={'id'} size={'small'} columns={columns} dataSource={data} />
                                <a style={{ float: 'right', marginRight: '12px',marginTop: '8px' }} onClick={() => onMore()} disabled={disabled}>查看更多</a>
                            </div>
                        </TabPane>
                        <TabPane tab="推送消息" key="2">
                            <div>
                                <Table bordered pagination={false} loading={loading} size={'small'} rowKey={'id'} columns={columns} dataSource={data} />
                                <a style={{ float: 'right', marginRight: '12px', marginTop: '8px' }} onClick={() => onMore()} disabled={disabled}>查看更多</a>
                            </div>
                        </TabPane>
                    </Tabs>
                </Modal>
                {/*推送富文本内容*/}
                <Modal
                    title=""
                    visible={contentVisible}
                    width={600}
                    onCancel={()=>contentCancel()}
                    footer={[
                        <Button key="back" onClick={()=>contentCancel()}>
                            关闭
                        </Button>
                    ]}
                >
                    <div dangerouslySetInnerHTML={{ __html: content }}></div>
                </Modal>
            </Header>
    )
}
export default Headers
